import { ReactNode } from 'react';
import {
  datadogAllowProps,
  datadogPhiMaskProps,
} from 'toolkit/environment/environment/userMonitoring.util';

/**
 * Static chrome that is safe to reveal in Session Replay.
 *
 * Replay defaults to mask, so labels only become readable when wrapped here.
 * Never put member-identifying values in this subtree.
 * @param props.children - Static copy with no member data.
 * @returns A span marked `data-dd-privacy="allow"`.
 */
export const DatadogReplayStatic = ({ children }: { children: ReactNode }) => (
  <span {...datadogAllowProps}>{children}</span>
);

/**
 * Member-identifying or clinical text that must stay masked, even under
 * allowed chrome.
 * @param props.children - Values from a member record or clinical free text.
 * @returns A span marked `data-dd-privacy="mask"`.
 */
export const DatadogReplayPhi = ({ children }: { children: ReactNode }) => (
  <span {...datadogPhiMaskProps}>{children}</span>
);

/**
 * Allows a fully static title string. Mixed titles must already wrap PHI in
 * {@link DatadogReplayPhi} — those React nodes pass through unchanged.
 * @param title - Dialog, drawer, or confirmation heading.
 * @returns Title content with Session Replay privacy applied.
 */
export const wrapDatadogReplayTitle = (title: ReactNode): ReactNode => {
  if (typeof title === 'string' || typeof title === 'number') {
    return <DatadogReplayStatic>{title}</DatadogReplayStatic>;
  }
  return title;
};
